import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  fetchProfilesSuggestionsError,
  fetchProfilesSuggestionsSuccess,
  getPreviewError,
  getPreviewSuccess,
  testScenarioError,
  testScenarioSuccess,
} from './actions'
import {
  FETCH_PROFILES_SUGGESTIONS_ASYNC,
  GET_PREVIEW_ASYNC,
  TEST_SCENARIO_ASYNC,
} from './constants'

const getPreviewEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_PREVIEW_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .previewScenario(
        action.payload.id,
        action.payload.locale,
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) => getPreviewSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(getPreviewError, error, [400])))
      .takeUntil(action$.ofType(GET_PREVIEW_ASYNC.CANCEL))
  )

const fetchProfilesSuggestionsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_PROFILES_SUGGESTIONS_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .getEmails(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.search,
        false
      )
      .map((response) => fetchProfilesSuggestionsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchProfilesSuggestionsError, error)))
      .takeUntil(action$.ofType(FETCH_PROFILES_SUGGESTIONS_ASYNC.CANCEL))
  )

const testScenarioEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(TEST_SCENARIO_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .testScenario(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.id,
        action.payload.locale,
        action.payload.values,
        action.payload.deliveryType
      )
      .map(({ response }) => testScenarioSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(testScenarioError, error)))
      .takeUntil(action$.ofType(TEST_SCENARIO_ASYNC.CANCEL))
  )
export default combineEpics(getPreviewEpic, fetchProfilesSuggestionsEpic, testScenarioEpic)
